
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-center",
      function () {
        return require("private-next-pages/learning-center/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-center"])
      });
    }
  